<template>
  <div class="addr-box" style="padding: 0 22px;">
    <!-- <div class="prompt">
      <van-icon name="volume-o" size="14" color="#F1892E" />
      <div class="text">请确认收货地址手否准确，如不准确请拖动地图进行调整</div>
    </div> -->
    <van-form :show-error-message="false" validate-trigger="onChange" @submit="submit" @failed="failed">
      <div class="title-info flex-sb" @click="handleOpenSearch">
        <span class="details-address">{{mapCenterInfo.detailedAddress}}</span>
        <span style="font-size:12px;color:#A4A4A4;">更改</span>
      </div>
      <van-cell-group inset>
        <div class="input-box">
          <van-field
            v-model.trim="form.remark"
            name="详细地址"
            placeholder="请输入详细地址"
            class="input"
            maxlength="50"
            @blur="formChange"
          />
        </div>
        <div class="input-box">
          <van-field
            v-model.trim="form.factoryName"
            name="工厂名称"
            placeholder="请输入工厂名称"
            class="input"
            maxlength="50"
            :rules="[{ required: true, message: '请输入工厂名称' }]"
            @blur="formChange"
          />
        </div>
        <div class="input-box">
          <van-field
            v-model.trim="form.factoryLinkName"
            name="联系人"
            placeholder="联系人"
            class="input"
            style="width:40%;"
            maxlength="15"
            :rules="[{ required: true, message: '请填写姓名' }]"
            @blur="formChange"
          />
          <van-field
            v-model.trim="form.factoryLinkPhone"
            name="手机/座机"
            placeholder="手机/座机"
            class="input"
            maxlength="30"
            :rules="[
              { required: true, message: '请填写手机/座机' },
              { pattern: /^((0\d{2,3}-\d{7,8})|(1\d{10})|(\d{7,8}))$/, message: '请填写正确的手机/座机' },
            ]"
            @blur="formChange"
          />
        </div>
      </van-cell-group>
      <van-button 
        round block 
        type="warning" 
        color="linear-gradient(129deg, #F1892E 0%, #F1BC3F 100%)" 
        native-type="submit" 
        class="footer-button"
      >确认</van-button>
    </van-form>
  </div>
</template>

<script>
import { Image , Field , Cell , CellGroup , Form , RadioGroup, Radio , Button , Toast , Icon } from 'vant';
export default {
  name:'dispatch-address-info',
  props:['mapCenterInfo','openSearch','queryParams'],
  components:{ 
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
   },
  data(){
    return {
      form:{
        factoryLinkName:'',
        factoryLinkPhone:'',
        remark:'',
        factoryName:''
      }
    }
  },
  watch:{
    queryParams:{
      handler(val){
        this.form = {
          factoryLinkName:val.factoryLinkName,
          factoryLinkPhone:val.factoryLinkPhone,
          remark:val.remark,
          factoryName:val.factoryName
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    formChange(){
      this.$emit('update:queryParams',{
        ...this.queryParams,
        ...this.deepClone(this.form)
      })
    },
    handleOpenSearch(){
      this.$emit('update:openSearch',true);
    },
    submit(){
      window.uni.postMessage({
        data: this.queryParams
      });
      window.uni.navigateBack({
				delta:1
			})
    },
    failed({ errors }){
      Toast.fail(errors[0].message);
    }
  }
}
</script>

<style scoped lang="scss">
  .addr-box {
      background-color: #FFF;
      box-sizing: border-box;
      position: relative;
      .prompt {
        position: relative;
        left: 0;
        right: 0;
        top: -30px;
        z-index: 999999999;
        height: 38px;
        background-color: #FFEAD8;
        padding: 9px 10px 17px 10px;
        display: flex;
        .text {
          font-size: 13px;
          color: #F1892E;
          margin-left: 8px;
        }
      }
      * {
        color: #130A01;
      }
      .van-form {
        .van-cell-group {
          margin: 0;
        }
        .title-info {
          height: 56px;
          // flex-wrap: wrap;
          overflow: hidden;
          .details-address {
            flex: 1;
            font-size: 16px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
          }
        }
        .group-addr {
          padding-left: 0;
          padding: 15px 0;
        }
        .input-box {
          height: 36px;
          overflow: hidden;
          background-color: #F5F5F5;
          border-radius: 6px;
          display: flex;
          margin-bottom: 20px;
          .input {
            background-color: #F5F5F5;
            height: 36px;
            line-height: 0;
            font-size: 16px;
          }
        }
        .footer-button {
          margin-bottom: 20px;
          background: linear-gradient(129deg, #F1892E 0%, #F1BC3F 100%);
          border-radius: 20px 20px 20px 20px;
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 5px;
          user-select: none;
          * {
            color: #FFF;
          }
        }
      }
    }
  ::v-deep .van-field__label {
    font-size: 16px;
    color: #1E1E1E;
  }
</style>